const mobile_tasks = {
    utils: {
        is_single_account_submitter: function () {
            return $f.active_user.is_submitter() && $f.mobile.dashboard.is_single_account_owner();
        }
    },
    buckets_collapsed_states: {}, // stores the state of buckets on both tasks page and dashboard tasks tab
    location_buckets_collapsed_states: {}, // stores the state of location buckets on both tasks page and dashboard tasks tab

    initialize: function () {
        var this_ = this;

        $f.application.vent.on('nav:clear', function () {
            this_.reset_buckets_collapsed_states();
        });
    },

    reset_buckets_collapsed_states: function () {
        this.buckets_collapsed_states = {};
        this.location_buckets_collapsed_states = {};
    },

    /**
     * Because our backbone cache only caches results, we need to keep track of our `results_count`s separately,
     * so we can display the total number of overdue tasks (for example) without being online.
     *
     * @author:david This is only used by tasks for now, though it could be used for any collection type. Ideally we
     * will graduate to another 3rd party caching mechanisms that will do this for us, though.
     */
    results_count_cache: {
        RESULTS_COUNT_CACHE_KEY: 'results_counts_by_cache_keys',

        update_results_count: function (cache_key, number, callback) {
            var this_ = this;

            $f.mobile.cache.get(this.RESULTS_COUNT_CACHE_KEY, function (result_counts_by_cache) {
                result_counts_by_cache = result_counts_by_cache || {};

                result_counts_by_cache[cache_key] = number;
                $f.mobile.cache.set(this_.RESULTS_COUNT_CACHE_KEY, result_counts_by_cache, callback);
            });
        },

        get_results_count: function (cache_key, callback) {
            $f.mobile.cache.get(this.RESULTS_COUNT_CACHE_KEY, function (result_counts_by_cache) {
                result_counts_by_cache = result_counts_by_cache || {};
                callback(result_counts_by_cache[cache_key]);
            });
        }
    }
};

export default mobile_tasks;
